export const DEFAULT_MAX_PER_SIZE = 125

/** B2B concierge contact email surfaced in self-serve error messaging. */
// eslint-disable-next-line i18next/no-literal-string
export const B2B_EMAIL = 'concierge@onequince.com'

/** When true, product image and title in the B2B cart (page + popup) link to the PDP. */
export const ENABLE_CART_PDP_LINK = true
